import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterBar } from "./components/FilterBar";
import { LicenseChecksGrid } from "./components/LicenseChecksGrid";
import useLatestLicenseChecks from "./hooks/useLatestLicenseChecks";
import { RESULTS_LIMIT_USER } from "@/constants/resultsLimits";
import { useFormattedNumber } from "@/hooks/metrics/useFormattedNumber";
import { getErrorMessage } from "@/utilities/error/getErrorMessage";

export default function LicenseCheckAdminPage() {
  const [results, setResults] = useState<string[]>([]);
  const [userTypes, setUserTypes] = useState<string[]>([]);
  const [user, setUser] = useState<string>();
  const [detailedView, setDetailedView] = useState(false);
  const {
    data: latestLicenseChecks,
    refetch,
    isLoading,
    isUsersError,
    usersError,
    isUsersTruncated,
  } = useLatestLicenseChecks({
    results,
    userTypes,
    detailedView,
  });

  const { t } = useTranslation();
  const userLimit = useFormattedNumber(RESULTS_LIMIT_USER);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  return (
    <Stack sx={{ height: "100%" }}>
      <FilterBar
        isMobile={isMobile}
        onUserTypeChange={setUserTypes}
        onResultChange={setResults}
        onUserChange={setUser}
        refresh={refetch}
        detailedView={detailedView}
        toggleDetailedView={() => setDetailedView(!detailedView)}
      />
      <Divider />
      {isUsersError && (
        <Alert severity="error">
          {t("licenseCheckAdmin.usersLoadError")} {getErrorMessage(usersError)}
        </Alert>
      )}
      {isUsersTruncated && (
        <Alert severity="warning">{t("licenseCheckAdmin.truncated", { limit: userLimit })}</Alert>
      )}
      <LicenseChecksGrid
        detailedView={detailedView}
        loading={isLoading}
        exportDisabled={isUsersError || isUsersTruncated}
        data={
          user ? latestLicenseChecks.filter(check => check.userId === user) : latestLicenseChecks
        }
      />
    </Stack>
  );
}
